import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseAddTagsToCategoryMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface AddTagsToCategoryMutationParams {
	categoryId: string;
	expandTags?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	tags?: Api.IAccountTag[];
}

export function useAddTagsToCategoryMutation({ onSuccess, onError }: UseAddTagsToCategoryMutationOptions = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({ categoryId, impersonationContext, tags = [] }: AddTagsToCategoryMutationParams) => {
			const tagNames = tags.map(tag => tag.name);
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tagcategory/${categoryId}/addTags?createTagIfMissing=true`,
				}),
				'POST',
				tagNames
			);
		},
		onSuccess,
		onError,
	});
}
